export default __webpack_public_path__ + "static/media/arrow_left.a1ae1e71.svg";